<template>
  <div class="folder-breadcrumbs d-flex align-items-center">
    <div class="d-flex align-items-center gap-2">
      <template v-for="(crumb, i) in visibleBreadcrumbs">
        <eg-icon
          v-if="i > 0"
          :key="`separator-${i}`"
          icon="chevron-right"
          size="small"
          color="var(--color-icon-neutral-default)"
        />
        <router-link
          v-if="i < visibleBreadcrumbs.length - 1"
          :key="`link-${crumb.id}-${i}`"
          class="float-left crumb link paragraph-s"
          :to="{
            name: 'workspace',
            params: { workspaceKey: $route.params.workspaceKey, id: crumb.id },
          }"
        >
          {{ crumb.name }}
        </router-link>
        <span
          v-else
          :key="`text-${crumb.id || 'current'}-${i}`"
          class="float-left crumb paragraph-s"
        >
          {{ crumb.name }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "FolderBreadcrumbs",

  inject: ["workspacesProvider"],

  props: {
    folderParentId: {
      type: [String, Number],
      required: true,
    },
    folderName: {
      type: String,
      required: true,
    },
  },

  computed: {
    breadcrumbs() {
      if (this.folderParentId) {
        const ancestors = this.workspacesProvider
          .getFolderAncestors(
            this.$route.params.workspaceKey,
            this.folderParentId
          )
          .map(({ id, name }) => ({ id, name }));
        return [...ancestors, { id: null, name: this.folderName }];
      }
      return [{ id: null, name: this.folderName }];
    },

    visibleBreadcrumbs() {
      // Limit to last 3 items (max depth 3)
      const start = Math.max(0, this.breadcrumbs.length - 3);
      return this.breadcrumbs.slice(start);
    },
  },
};
</script>

<style scoped lang="scss">
.crumb {
  text-decoration: none;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  color: var(--color-text-neutral-secondary);

  &:not(.link) {
    color: var(--color-text-neutral-on-white);
  }

  &.link:hover {
    color: var(--color-text-primary-default);
  }
}

.gap-2 {
  gap: 8px;
}
</style>
